import { Validation, ValidationType } from 'shared/types'

const validationKeys: ValidationType[] = [
  'emailRegex',
  'phoneNumberRegex',
  'amountRegex',
  'businessRegistryNumberRegex',
]

const baseValidationValues: Validation = {
  emailRegex:
    // eslint-disable-next-line no-useless-escape
    /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
  phoneNumberRegex: /^[0-9]*$/,
  amountRegex: /^[0-9]\d*$|^[0-9]\d*[.|,]\d{1,2}$/,
  businessRegistryNumberRegex: /^[0-9]*$/,
  taxNumberRegex: /^[0-9]*$/,
  passwordRegex:
    // eslint-disable-next-line no-useless-escape
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-“!@#%&\/,><\’:;|_~`])\S{8,99}$/,
}

export const REQUIRED_SPECIAL_CHARACTERS = `^$*.[]{}()?"!@#%&/,><':;|_~`.split(
  ''
)

export const getValidationRules = (): Validation =>
  validationKeys.reduce((acc, item) => {
    const currentItem = sessionStorage.getItem(item)
    return currentItem ? { ...acc, [item]: currentItem } : acc
  }, baseValidationValues)
